import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  element: '.js-modal[id]',
  closeButton: '.js-modal__close-button'
}

class Modal {
  constructor (element) {
    this.element = element
    this.closeButton = this.element.querySelector(SELECTORS.closeButton)
    this.trigger = null
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.init()
  }

  get isOpen() {
    return this.element.classList.contains('modal--is-open') || this.element.classList.contains('modal--is-opening')
  }

  /**
   * Initialize events and behaviors.
   */
  init() {
    // Wire up our close button.
    this.closeButton.addEventListener('click', () => {
      this.startClosing()
    })

    // Wire up trigger links.
    document.querySelectorAll(`[href^="#${this.element.id}"]`).forEach((trigger) => {
      trigger.addEventListener('click', event => {
        event.preventDefault()
        this.trigger = trigger
        this.startOpening()
      })
    })

    // Provide more sophisticated state transitions.
    this.element.addEventListener('transitionend', () => {
      this.onTransitionEnd()
    })

    // When another modal is opened, close this one.
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.MODAL_OPENED, (otherModal) => {
      if (this.isOpen && otherModal !== this) {
        this.startClosingWithoutCleanup()
      }
    })

    // Allow closing via the escape key.
    document.addEventListener('keydown', (event) => {
      if (this.isOpen && event.key === 'Escape') {
        this.startClosing()
      }
    })
  }

  /**
   * Handle completed state transitions.
   */
  onTransitionEnd() {
    if (this.element.classList.contains('modal--is-closing')) {
      this.finishClosing()
    } else if (this.element.classList.contains('modal--is-opening')) {
      this.finishOpening()
    }
  }

  /**
   * Begin opening this modal.
   */
  startOpening() {
    document.documentElement.classList.add('modal-is-open')

    this.element.classList.add('modal--is-opening')
    this.emitter.emit(GLOBAL_CONSTANTS.EVENTS.MODAL_OPENED, this)
  }

  /**
   * Finish opening this modal.
   */
  finishOpening() {
    this.element.classList.remove('modal--is-opening')
    this.element.classList.add('modal--is-open')
    this.closeButton.focus()
  }

  /**
   * Begin closing this modal and clean up the global/root modal state.
   */
  startClosing() {
    // Remove root state class.
    document.documentElement.classList.remove('modal-is-open')

    // Return focus to our triggering element.
    if (this.trigger) {
      this.trigger.focus()
    }

    // Transition to closed.
    this.startClosingWithoutCleanup()
  }

  /**
   * Begin closing this modal without cleaning up the global/root modal state.
   */
  startClosingWithoutCleanup() {
    this.element.classList.remove('modal--is-open')
    this.element.classList.add('modal--is-closing')
    this.emitter.emit(GLOBAL_CONSTANTS.EVENTS.MODAL_CLOSED, this)
  }

  /**
   * Finish closing this modal.
   */
  finishClosing() {
    this.element.classList.remove('modal--is-closing')
    this.trigger = null
  }
}

export default {
  selector: SELECTORS.element,
  Source: Modal
}
